<template>
  <div class="adjudicate">
    <Row class="detail-header">
      <span>判决</span>
      <Button
        v-if="infoCtrl && isDetailLoad && editState && caseState !== 'TN'" type="primary"
        style="margin-left: 10px;" @click="infoCtrl=false"
      >修改</Button>
    </Row>
    <Row class="case-content">
      <Row v-if="!infoCtrl && isDetailLoad" class="case-form flex-class">
        <Form
          ref="formValidate" :model="formValidate"
          :rules="ruleValidate"
          :label-width="100"
        >
          <FormItem label="判决日期" prop="judgmentDate">
            <DatePicker
              v-autoFill="autoFill.judgmentDate"
              transfer
              :value="formValidate.judgmentDate"
              style="width:100%"
              type="date"
              format="yyyy-MM-dd"
              placeholder="请填写判决日期"
              @on-change="getInputValue($event,'judgmentDate')"
            />
          </FormItem>
          <FormItem label="签收日期" prop="signDate">
            <DatePicker
              transfer
              :value="formValidate.signDate"
              style="width:100%"
              type="date"
              format="yyyy-MM-dd"
              placeholder="请填写签收日期"
              @on-change="getInputValue($event,'signDate')"
            />
          </FormItem>
          <FormItem label="判决金额" prop="amount">
            <my-input
              ref="amountRef"
              v-autoFill="autoFill.amount"
              append-text="￥"
              :default-data="formValidate.amount"
              :to-fixed="2"
              @getValue="getInputValue($event,'amount')"
            />
          </FormItem>
          <FormItem label="对方承担诉讼费金额" prop="litigantFee">
            <my-input
              append-text="￥"
              :default-data="formValidate.litigantFee"
              :to-fixed="2"
              @getValue="getInputValue($event,'litigantFee')"
            />
          </FormItem>
          <FormItem label="判决摘录" prop="remark">
            <Input
              v-model.trim="formValidate.remark" v-autoFill="autoFill.remark"
              type="textarea" :autosize="{minRows: 2,maxRows: 5}"
              placeholder="请输入备注"
            />
          </FormItem>
          <FormItem label="判决书" prop="attachments">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList"
            />
          </FormItem>
          <FormItem label="判决结果" prop="result">
            <RadioGroup v-model="formValidate.result">
              <Radio :label="1">胜诉</Radio>
              <Radio :label="0">败诉</Radio>
            </RadioGroup>
          </FormItem>
          <div class="detail-btn-box">
            <Button
              type="primary" style="margin-right:10px;"
              :disabled="isSubmit" @click="submit"
            >
              保存
            </Button>
            <Button @click="infoCtrl=true">取消</Button>
          </div>
        </Form>
      </Row>
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content flex-class">
        <Row><Col span="8" class="left-label">判决日期：</Col><Col span="13" class="right-content">{{ defaultData.judgmentDate || "" }}</Col></Row>
        <Row><Col span="8" class="left-label">签收日期：</Col><Col span="13" class="right-content">{{ defaultData.signDate || "" }}</Col></Row>
        <Row><Col span="8" class="left-label">判决金额：</Col><Col span="13" class="right-content">{{ common.formateNumber(defaultData.amount || "") }}</Col></Row>
        <Row><Col span="8" class="left-label">对方承担诉讼费金额：</Col><Col span="13" class="right-content">{{ common.formateNumber(defaultData.litigantFee || "") }}</Col></Row>
        <Row><Col span="8" class="left-label">判决摘录：</Col><Col span="13" class="right-content">{{ defaultData.remark || "" }}</Col></Row>
        <Row>
          <Col span="8" class="left-label">判决书：</Col>
          <Col span="13" class="right-content">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row><Col span="8" class="left-label">判决结果：</Col><Col span="13" class="right-content">{{ defaultData.result?"胜诉":"败诉" }}</Col></Row>
      </Row>
      <judge-result
        v-if="isJudgeResult" :process-id="processId"
        :judge-type="judgeType"
        @reloadProcess="$emit('reloadProcess')"
      />
    </Row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import getQccKeyData from '@/libs/qcc.js'
import JudgeResult from '@/view/civilCase/adjudicate/judgeResult.vue'

export default {
  components: {
    JudgeResult
  },
  props: ['caseId', 'processId', 'editState', 'caseState', 'isJudgeResult', 'judgeType'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      infoCtrl: true,
      isSubmit: false,
      isDetailLoad: false,
      defaultData: '',
      formValidate: {
        judgmentDate: '',
        signDate: '',
        amount: '',
        litigantFee: '',
        remark: '',
        attachments: [],
        result: ''
      },
      ruleValidate: {
        judgmentDate: [{ required: true, message: '判决日期不能为空', trigger: 'change' }],
        signDate: [{ required: true, message: '签收日期不能为空', trigger: 'change' }],
        amount: [{ required: true, message: '判决金额不能为空', trigger: 'blur' }, { validator: overMillion, trigger: 'blur' }],
        litigantFee: [{ required: true, message: '对方承担诉讼费金额不能为空', trigger: 'blur' }, { validator: overMillion, trigger: 'blur' }],
        attachments: [{ required: true, type: 'array', message: '判决书不能为空', trigger: 'blur' }],
        result: [{ required: true, type: 'number', message: '判决结果不能为空', trigger: 'change' }]
      },
      defaultList: [],
      hasDetail: false,
      autoFill: {
        judgmentDate: false,
        amount: false,
        remark: false
      }
    }
  },
  computed: {
    ...mapGetters(['qccData']),
    qccWatch() {
      return {
        isDetailLoad: this.isDetailLoad,
        hasData: !!this.qccData.length
      }
    }
  },
  watch: {
    qccWatch: {
      handler: async function(value) {
        if (value.isDetailLoad && value.hasData && !this.hasDetail && !this.infoCtrl) {
          this.formValidate.judgmentDate = await getQccKeyData(this.qccData, 'judgmentDate')
          this.autoFill.judgmentDate = !!this.formValidate.judgmentDate
          this.formValidate.amount = await getQccKeyData(this.qccData, 'amount')
          this.$nextTick(() => {
            this.$refs.amountRef.toShow()
          })
          this.autoFill.amount = !!this.formValidate.amount
          this.formValidate.remark = await getQccKeyData(this.qccData, 'remark')
          this.autoFill.remark = !!this.formValidate.remark
        }
      },
      deep: true
    }
  },
  created() {},
  beforeMount() {
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    // 获取判决详情
    getDetail() {
      const url = '/business/case/judgment?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
          this.hasDetail = true
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
          this.hasDetail = false
        }
      })
    },
    getInputValue(data, name) {
      this.formValidate[name] = data
      if (this.autoFill[name]) { this.autoFill[name] = false }
    },
    // 获取图片列表
    getAttachmentList (arr) {
      this.formValidate.attachments = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachments.push(obj)
      })
    },
    // 赋默认值
    giveDefaultData() {
      this.formValidate.judgmentDate = this.defaultData.judgmentDate
      this.formValidate.signDate = this.defaultData.signDate
      this.formValidate.amount = this.defaultData.amount
      this.formValidate.litigantFee = this.defaultData.litigantFee
      this.formValidate.remark = this.defaultData.remark
      this.formValidate.attachments = this.defaultData.attachments
      this.formValidate.result = this.defaultData.result ? 1 : 0
      this.defaultList = this.defaultData.attachments

      this.isDetailLoad = true
    },
    submit() {
      let url = '/business/case/judgment'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formValidate)
      if (this.defaultData) {
        url += `/${this.defaultData.id}`
        this.$refs['formValidate'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formValidate'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
.case-content {
  display: flex;
  .flex-class {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/adjudicate/index.vue